<template>
    <Table
        ref="table"
        :scroll="{ x: 1500, }"
        :data="measures"
        :loading="loading"
        :pagination="pagination"
        :columns="columns"
        :custom-row="customRow"
        @change="handleTableChange"
    />
</template>

<script>
import Table from './Table.vue';
import tableMixin from '@/mixins/tableMixin';

export default {
    name: 'MeasureTable',
    components: {
        Table,
    },
    mixins: [tableMixin('measures')],
    props: {
        measures: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        pagination: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    data() {
        return {
            columns: [
                this.columnFor('abbreviation', { fixed: 'left', width: 170 }),
                this.columnFor('name',{ width: 150 }),
                this.columnFor('version',{ width: 150 }),
                this.columnFor('targetPopulation',{ width: 200 }),
                this.columnFor('domain',{ width: 150 }),
                this.columnFor('type',{ width: 150 }),
                this.columnFor('system',{ width: 150 }),
                this.columnFor('language',{ width: 150 }),
                this.columnFor('description',{ width: 150 }),
                this.columnFor('settings',{ width: 150 }),
                this.columnFor('itemsAndResponses',{ width: 230 }),
                this.columnFor('cost',{ width: 150, customRender: this.$formatMoney }),
                this.columnFor('status', { fixed: 'right', width: 150 }),
                this.columnFor('comments', { fixed: 'right', width: 250 }),
            ],
        };
    },
};
</script>

<style>
</style>
